var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAudioMute = function SvgAudioMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "audio_mute_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".audio_mute_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "audio_mute_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "audio_mute_svg__st1",
    d: "M16.36 12V4.5C16.36 2.01 14.41 0 12 0S7.64 2.01 7.64 4.5v.17l8.55 8.55c.09-.4.17-.8.17-1.22zM19.99 12v-1.92C19.99 9.5 19.5 9 18.9 9c-.6 0-1.09.5-1.09 1.08V12c0 .84-.17 1.64-.48 2.37l1.64 1.64A8.322 8.322 0 0 0 19.99 12zM21.72 20.36 3.68 2.32a.996.996 0 1 0-1.41 1.41L7.64 9.1V12c0 2.48 1.91 4.5 4.36 4.5.86 0 1.64-.28 2.32-.72l1.08 1.08a5.686 5.686 0 0 1-3.77 1.13c-3-.2-5.44-3.12-5.44-6.22v-1.68c0-.58-.49-1.08-1.09-1.08-.6 0-1.09.5-1.09 1.08v1.51c0 4.2 2.91 7.95 6.91 8.52v1.64H9.1c-.83 0-1.49.71-1.45 1.57.02.38.35.67.73.67h7.27c.37 0 .71-.29.73-.68.04-.86-.63-1.57-1.45-1.57h-1.82v-1.58a7.89 7.89 0 0 0 3.88-1.73l3.34 3.34c.2.2.45.29.71.29s.51-.1.71-.29c.36-.39.36-1.03-.03-1.42z"
  })));
};
export default SvgAudioMute;